import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    isLayoutMobile?: boolean;
  }>()
  .create(({ theme, isLayoutMobile }) => ({
    watchersList: {
      marginBottom: theme.spacing(2),
      padding: theme.spacing(0, 0, 1, 2),
      ...(!isLayoutMobile && {
        maxHeight: '16rem',
        overflowY: 'auto'
      })
    },
    watchersListItem: {
      padding: 0
    },
    watchersListItemAvatar: {
      marginRight: theme.spacing(1),
      minWidth: 0
    },
    watchersListItemText: {
      '& .MuiTypography-body1': {
        color: theme.vars.palette.text.primary,
        fontSize: '0.75rem',
        lineHeight: '0.875rem'
      },
      '& .MuiTypography-body2': {
        color: theme.vars.palette.transparent.a50,
        fontSize: '0.6875rem',
        lineHeight: '0.75rem'
      }
    },
    watchersListItemTextWarning: {
      '& .MuiTypography-body1': {
        color: theme.vars.palette.warning.main,
        fontSize: '0.75rem',
        lineHeight: '0.875rem'
      },
      '& .MuiTypography-body2': {
        color: theme.vars.palette.transparent.a50,
        fontSize: '0.6875rem',
        lineHeight: '0.75rem'
      }
    }
  }));

export default useStyles;
